const recommend = [
    {title : "축구에 미친 여자 있음?"},
    {title : "풋살 매칭 하실 팀 구해요~~"},
    {title : "프리다이빙 다이버 구해요"},
    {title : "드라이버 잘 치는 사람"},
    {title : "어쩌고 저쩌고 아는 사람"},
    {title : "보스턴 어쩌구 워싱턴"},
    {title : "평일 저녁 어쩌구 회원 모집"},
    {title : "서핑 어쩌구 레슨 추천"},
    {title : "시간을 되돌리면 어쩌구 경기"},
    {title : "시험 공부 안해 이것도 안할래"}
]

export default recommend;